import {
    withJsonFormsOneOfEnumCellProps,
    withTranslateProps,
} from '@jsonforms/react'
import { DynamicOneOfControl } from './DynamicOneOfControl'

export default withJsonFormsOneOfEnumCellProps(
    withTranslateProps(DynamicOneOfControl)
)
